<script setup lang="ts">
import { BeamShapingGroupCircularDto, TaskTypeDescription } from '@/api/generator';
import VeeEnumerationValue from '@/components/forms/dataTypes/VeeEnumerationValue.vue';
import VeeNumericValueField from '@/components/forms/dataTypes/VeeNumericValueField.vue';
import { useFormMode } from '@/components/forms/useFormMode.ts';
import { I18nKey } from '@/utils/typings.ts';
import { useField } from 'vee-validate';
import { toRef } from 'vue';

type BeamShapingGroupCircularProps = {
  name: string;
  taskType: TaskTypeDescription;
};
const props = defineProps<BeamShapingGroupCircularProps>();

const mode = useFormMode();

const emits = defineEmits<{
  blur: [event?: FocusEvent];
}>();

const { value: item, setTouched } = useField<BeamShapingGroupCircularDto>(toRef(() => props.name));

function blur() {
  setTouched(true);
  emits('blur');
}
</script>

<template>
  <td class="symmetry">
    <VeeEnumerationValue
      :disabled="true"
      :name="`${name}.radiationFieldSymmetry`"
      :items="
        item?.radiationFieldSymmetry?.options?.map((option) => {
          return {
            title: `${$t(option.name as I18nKey)}`,
            value: option,
            props: {
              disabled: option.name !== ('EnumerationOptionLabelEnum.Symmetrical' as I18nKey),
            },
          };
        })
      "
      :mode="'details'"
      @blur="blur"
    />
  </td>
  <td class="size">
    <VeeNumericValueField
      class="align-center justify-end"
      :name="`${name}.radiationFieldSize`"
      :mode="mode"
      :prefix="$t(item.radiationFieldSize?.geometry?.name as I18nKey)"
      @update:modelValue="blur"
    />
  </td>
  <td></td>
</template>
